import React, { Component } from 'react';
import { View, ActivityIndicator } from 'react-native';

import styles from './styles';

export default class Loading extends Component {
    render() {
        const { loading } = this.props;

        if (!loading) return null;

        return (
            <View style={[styles.btn, styles.loadingIcon]}>
                <ActivityIndicator />
            </View>
        );
    }
}
